var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFamilySettings = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 284 182"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#jottacloud_FamilySettings.svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#45434C",
  d: "m93.027 123.721-5.236-9.068c-2.892-5.009-9.296-6.725-14.305-3.833s-6.725 9.296-3.833 14.305c2.892 5.008 9.297 6.724 14.305 3.833zm-73.95 2.426 9.841 3.583c5.435 1.977 11.445-.825 13.423-6.26s-.825-11.444-6.26-13.422-11.444.824-13.422 6.259z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M36.833 122.777a2.889 2.889 0 1 0 0-5.777 2.889 2.889 0 0 0 0 5.777m38.278 0a2.889 2.889 0 1 0 0-5.777 2.889 2.889 0 0 0 0 5.777"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M31.778 135.777c0-14.3 10.587-26 23.53-26h2.05c12.943 0 23.53 11.7 23.53 26",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#45434C",
  strokeLinecap: "round",
  d: "M31.778 135.777c0-14.3 10.587-26 23.53-26h2.05c12.943 0 23.53 11.7 23.53 26"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M77.278 135.055v15.739c0 11.999-9.187 21.817-20.415 21.817h-1.781c-11.229 0-20.415-9.818-20.415-21.817v-15.739",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#45434C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m31.778 136.014 24.986.486 1.752-.012 3.198-7.933 3.52 7.71 14.933-.251"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#45434C",
  strokeLinecap: "round",
  d: "M78 146.611v3.779c0 12.221-9.343 22.221-20.761 22.221h-1.811c-11.419 0-20.761-10-20.761-22.221v-3.779"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#45434C",
  strokeLinecap: "round",
  d: "M36.11 147.333c-1.993 0-3.61-1.778-3.61-3.972s1.617-3.972 3.61-3.972m41.89-.722c1.994 0 3.61 1.778 3.61 3.972s-1.616 3.972-3.61 3.972"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#45434C",
  d: "M63.555 150.302c-.069 4.85-6.284 4.591-6.5-.08m-22.388 18.092S16.555 166.888 5.055 182m72.223-13c13.253.323 19.918 3.35 29.611 12.278"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#45434C",
  strokeLinejoin: "round",
  d: "M52.722 159.611c3.05 4.815 9.91 4.815 13.722 0 0 0-3.43.722-6.86.722s-6.862-.722-6.862-.722Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#45434C",
  strokeLinecap: "round",
  d: "M52.623 140.786c-2.758-.548-5.58.569-6.99 2.586m27.18-.988c-1.54-2.042-4.177-2.837-6.419-2.109"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#45434C",
  stroke: "#45434C",
  d: "M50.194 146.611a1.083 1.083 0 1 0 0-2.167 1.083 1.083 0 0 0 0 2.167Zm18.056 0a1.083 1.083 0 1 0 0-2.167 1.083 1.083 0 0 0 0 2.167Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#45434C",
  d: "M218.28 103.774c8.398-.065 16.294-3.676 22.228-10.17s9.169-15.054 9.109-24.108c0 0-.556-15.041-1.066-19.889-.262-2.482-1.25-2.1-1.25-2.1-.128-18.63-12.12-33.785-29.399-33.785h-.232c-8.4.065-16.293 3.68-22.228 10.17-5.935 6.494-9.171 15.057-9.109 24.111l.148 21.986c.128 18.63 14.288 33.786 31.567 33.786h.231z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m252.472 38.822-44.915.331-.076-10.378-6.417 10.426-6.341.047",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#45434C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M249.167 49.472 244.111 52l-3.394-12.133-36.824-.044-.226-5.156-7.158 5.156-10.898.044s2.167-26.145 31.417-26.145 33.944 21.667 33.944 24.556-1.805 11.194-1.805 11.194",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M212.008 89.068c2.952 1.502 6.445 2.113 10.021 1.521a16.34 16.34 0 0 0 9.039-4.682",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M220.321 94.213c-3.654 1.3-7.988-1.398-7.988-3.791a4.34 4.34 0 0 1 2.102-3.715 4.33 4.33 0 0 1 4.267-.112 4.334 4.334 0 0 1 7.498 2.96c0 2.394-4.783 4.268-5.879 4.658",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#45434C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M208.722 89.105c2.952 1.502 6.445 2.112 10.021 1.521a16.34 16.34 0 0 0 9.039-4.682"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#45434C",
  strokeLinecap: "round",
  d: "M237.422 56.229c-.99-1.845-2.656-3.552-4.771-4.293-3.705-1.294-7.669.338-9.823 3.42m-14.698-1.504a8.52 8.52 0 0 0-5.846-2.175c-2.938.051-5.507 1.59-7.022 3.892"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M248.458 69.228c5.376-.039 9.703-4.482 9.664-9.923-.041-5.439-4.43-9.819-9.805-9.779",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#45434C",
  strokeLinecap: "round",
  d: "M248.444 69.637a9.82 9.82 0 0 0 9.062-6.128 9.8 9.8 0 0 0 .722-3.774c-.041-5.54-4.42-9.94-9.784-9.902"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#45434C",
  d: "M215.882 60.667 209.444 75.4h11.267m28.046 17.205c20.632 4.534 37.604 27.365 32.548 54.728"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#45434C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m112.667 107.522 2.481-25.749s1.235-27.606 27.881-27.606 28.105 24.55 28.105 27.606c0 .37 1.934 26.571 1.934 26.571-3.096 0-17.918 3.672-30.039 3.485-14.345-.221-30.362-4.307-30.362-4.307",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#000",
  d: "M168.639 99.666a1.806 1.806 0 1 0 0-3.612 1.806 1.806 0 0 0 0 3.612Zm-51.278.723a1.805 1.805 0 1 1 0-3.61 1.805 1.805 0 0 1 0 3.61Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M166.12 87.848q3.94 2.899 3.963 5.615c.021 2.67-1.562 5.03-3.963 6.293v1.646c0 12.769-10.351 23.12-23.12 23.12s-23.12-10.351-23.12-23.12v-1.647c-2.4-1.263-3.985-3.622-3.963-6.292.021-2.716 1.613-5.06 3.963-6.307v-2.932",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#45434C",
  strokeLinecap: "round",
  d: "M166.12 87.848q3.94 2.899 3.963 5.615c.021 2.67-1.562 5.03-3.963 6.293v1.646c0 12.769-10.351 23.12-23.12 23.12s-23.12-10.351-23.12-23.12v-1.647c-2.4-1.263-3.985-3.622-3.963-6.292.021-2.716 1.613-5.06 3.963-6.307v-2.932"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#45434C",
  d: "M177.7 125.986a3917 3917 0 0 0-15.922-5.375"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m142.173 98.222-4.228 9.678h7.4",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#45434C",
  d: "m142.173 98.222-4.228 9.678h7.4"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  d: "M167.272 96.778a1.802 1.802 0 0 0 .835 2.894 1.8 1.8 0 0 0 1.931-.573m-51.261-1.646a1.82 1.82 0 0 1 .424 1.322 1.805 1.805 0 0 1-3.19 1"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#45434C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M134.333 114.382c2.952 1.503 6.445 2.113 10.021 1.522"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#45434C",
  strokeLinecap: "round",
  d: "M136.236 90.28c-2.608-1.708-5.951-1.396-8.203.55m30.002.188c-2.234-2.26-5.64-2.515-8.313-.856"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#45434C",
  stroke: "#45434C",
  d: "M133.756 94.755a1.3 1.3 0 1 0 0-2.6 1.3 1.3 0 0 0 0 2.6Zm20.944 0a1.3 1.3 0 1 0 0-2.6 1.3 1.3 0 0 0 0 2.6Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m166.328 83.922-31.032-.036-.191-12.29-6.032 12.29-9.184.036",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#45434C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m166.328 83.922-31.032-.036-.191-12.29-6.032 12.29-9.184.036"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#45434C",
  d: "M124.222 122.055q-15.889 3.973-22.389 22.389"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#45434C",
  strokeLinecap: "round",
  d: "M244.111 156.722c0 13.506-10.307 24.556-22.906 24.556h-1.996c-12.599 0-22.764-11.05-22.764-24.556"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#45434C",
  d: "M195.361 174.778c-11.194 3.611-34.305-7.223-36.472-14.084m52 7.584c3.371 4.815 10.954 4.815 15.167 0"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#45434C",
  strokeLinecap: "round",
  d: "M196.444 157.444c-1.994 0-3.611-1.94-3.611-4.333s1.617-4.333 3.611-4.333m17.456-2.329c-2.657-1.7-6.03-1.305-8.281.749m27.044-.105c-2.038-2.072-5.155-2.213-7.607-.564"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#45434C",
  stroke: "#45434C",
  d: "M210.889 153.833a1.443 1.443 0 1 0 0-2.889 1.444 1.444 0 0 0 0 2.889Zm18.055 0a1.444 1.444 0 1 0 .002-2.888 1.444 1.444 0 0 0-.002 2.888Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#45434C",
  d: "m218.73 153.111-4.952 8.666h8.667m22.027-11.555v-9.389m-48.027 16.25.541-14.083m48.57 28.889q11.757 0 18.055 4.333"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  stroke: "#45434C",
  strokeLinecap: "round",
  d: "M197.691 136.29c-.542-10.326 9.165-19.284 21.769-19.944l1.998-.105c12.604-.661 23.293 7.229 23.834 17.554l-47.602 2.495z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "m246.036 133.034-49.765 2.608a2.17 2.17 0 0 0-2.051 2.278l.189 3.606a2.166 2.166 0 0 0 2.277 2.05l49.765-2.608a2.17 2.17 0 0 0 2.051-2.277l-.189-3.606a2.17 2.17 0 0 0-2.277-2.051"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#45434C",
  d: "m245.694 133.414-49.044 2.57a2.166 2.166 0 0 0-2.05 2.277l.151 2.885a2.17 2.17 0 0 0 2.277 2.051l49.044-2.571a2.166 2.166 0 0 0 2.05-2.277l-.151-2.885a2.166 2.166 0 0 0-2.277-2.05Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M243.389 148.778c1.994 0 3.611 1.94 3.611 4.333s-1.617 4.333-3.611 4.333",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#45434C",
  strokeLinecap: "round",
  d: "M243.389 148.778c1.994 0 3.611 1.94 3.611 4.333s-1.617 4.333-3.611 4.333M38.341 43.102v18.85c0 14.37 18.128 26.127 33.929 26.127h2.505c15.801 0 23.529-11.758 23.529-26.128v-16.09"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#45434C",
  strokeLinecap: "round",
  d: "M98.304 47.233V32.6C96.686 16.05 82.439 6.768 67.848 5.129"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#45434C",
  d: "M87.389 71.789c0 1.675-3.395 3.033-7.584 3.033-4.188 0-7.583-1.358-7.583-3.033"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  d: "M75.833 47.667c1.044-1.517 2.959-2.167 4.695-2.167 1.734 0 3.29.652 4.333 2.167"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#000",
  d: "M93.742 56.46c-4.865 0-8.809-3.678-8.809-8.216s-.372-8.217 8.81-8.217c9.181 0 8.808 3.68 8.808 8.217s-3.943 8.217-8.809 8.217Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  d: "M66.155 56.46c-5.265 0-9.533-3.678-9.533-8.216s-.326-8.217 9.533-8.217 9.534 3.68 9.534 8.217-4.269 8.217-9.534 8.217Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#45434C",
  stroke: "#45434C",
  d: "M94.178 48.967a1.733 1.733 0 1 1 0-3.467 1.733 1.733 0 0 1 0 3.467Zm-27.878.288a1.733 1.733 0 1 1 0-3.467 1.733 1.733 0 0 1 0 3.467Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  d: "M56.333 47.089 39 41.889"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#45434C",
  d: "M40.589 84.066C14.083 88.833.36 105.3.36 125.666"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M39.197 39.966c-4.959 0-8.978 3.679-8.978 8.217s4.02 8.218 8.978 8.218",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#45434C",
  strokeLinecap: "round",
  d: "M39.197 39.966c-4.959 0-8.978 3.679-8.978 8.217s4.02 8.218 8.978 8.218"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M37.122 40.733q-.433-28.167 6.067-31.2c6.5-3.033 7.367-2.6 8.667-1.3 2.166-7.367 23.4-8.667 35.1-7.367s15.6 5.634 15.6 11.7c0 6.067 0 13.073-24.267 13.253q-24.267.18-23.4-8.053.433 13-5.2 13.434c.433 0 0 7.8 0 14.733q0 6.933-9.967 4.767",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#45434C",
  d: "M37.122 40.733q-.433-28.167 6.067-31.2c6.5-3.033 7.367-2.6 8.667-1.3 2.166-7.367 23.4-8.667 35.1-7.367s15.6 5.634 15.6 11.7c0 6.067 0 13.073-24.267 13.253q-24.267.18-23.4-8.053.433 13-5.2 13.434c.433 0 0 7.8 0 14.733q0 6.933-9.967 4.767"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#45434C",
  d: "M48.389 50.267C49.256 63.7 58.067 71.86 65 71.86m27.589-.794q3.869 0 5.633-6.5"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#45434C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M79.544 62.255c-8.624 0-15.23 4.657-15.23 10.4h19.03c.963 0 2.167-2.6 2.167-2.6s.819 2.6 1.734 2.6h6.578c0-5.743-6.606-10.4-14.279-10.4",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M74.844 58.194c.121 7.725 11.044 7.312 11.422-.128z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#45434C",
  d: "M74.844 58.194c.121 7.725 11.044 7.312 11.422-.128"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "jottacloud_FamilySettings.svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h283.111v182H0z"
})))));
export default SvgFamilySettings;